import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AplikasiComponent } from './aplikasi/aplikasi.component';
import { WebsiteComponent } from './website/website.component';
import { CmsComponent } from './cms/cms.component';
import { BelajarComponent } from './belajar/belajar.component';
import { AxcoraschoolComponent } from './axcoraschool/axcoraschool.component';
import { MediaComponent } from './belajar/media/media.component';
import { PremiumComponent } from './belajar/premium/premium.component';
import { SimpleComponent } from './belajar/simple/simple.component';
import { GratisComponent } from './belajar/gratis/gratis.component';
import { HomeComponent } from './home/home.component';
import { AbsensiComponent } from './absensi/absensi.component';
import { RapotComponent } from './rapot/rapot.component';
import { PembayaranComponent } from './pembayaran/pembayaran.component';
import { AxcoraschoolproComponent } from './axcoraschoolpro/axcoraschoolpro.component';

@NgModule({
  declarations: [
    AppComponent,
    AplikasiComponent,
    WebsiteComponent,
    CmsComponent,
    BelajarComponent,
    AxcoraschoolComponent,
    MediaComponent,
    PremiumComponent,
    SimpleComponent,
    GratisComponent,
    HomeComponent,
    AbsensiComponent,
    RapotComponent,
    PembayaranComponent,
    AxcoraschoolproComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [  
    Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
